
export enum SchedulerState { not_initialized, running, paused, stopped, error }
